import React, { Component } from 'react';
import { FormModalContainer, FormModalContent, ExercisesContainer } from './style';
import { CloseIconContainer } from '../style';
import { Text } from '../../../UI/Text';
import { Exercise } from '../../Rows/ExerciseRow';
import { Input } from '../../Inputs/InputContainer/index';
import { SearchInput } from './style';
import { getWorkoutTypes } from '../../../../data/workoutTypes';

const workoutTypes = getWorkoutTypes();

export class ChooseWorkoutTypeModal extends Component {
    state = {
        searchFilter: '',
    };

    handleSearchInput = ({ target: { value } }) => {
        this.setState({ searchFilter: value });
    };

    chooseType = id => {
        const { onChoose, onClose } = this.props;
        onChoose(id);
        onClose();
    };

    render() {
        const {
            props: { onClose },
            state: { searchFilter },
            handleSearchInput,
            chooseType,
        } = this;
        const filteredTypes = workoutTypes.filter(type => type.name.includes(searchFilter));

        return (
            <FormModalContainer>
                <FormModalContent>
                    <Text alignCenter marginBottom={'30px'} fontSize={22} weight={'bold'}>
                        Choose workout type
                    </Text>

                    <CloseIconContainer onClick={onClose}>
                        <i className="fas fa-times" />
                    </CloseIconContainer>

                    <div style={{ width: '100%', marginBottom: '30px' }}>
                        <Input>
                            <SearchInput onChange={handleSearchInput} placeholder={'Search'} />
                        </Input>
                    </div>

                    <ExercisesContainer>
                        {filteredTypes.map(type => (
                            <Exercise
                                onClick={chooseType.bind(this, type.id)}
                                key={type.id}
                                index={type.id}
                                name={type.name}
                                workoutIcon={type.icon}
                                isStatic={true}
                            />
                        ))}
                    </ExercisesContainer>
                </FormModalContent>
            </FormModalContainer>
        );
    }
}



// WEBPACK FOOTER //
// ./src/UI/Components/Modals/ChooseWorkoutTypeModal/index.js